import React, { useContext } from 'react'
import { DataExpenseContext } from '../types'
import { InputElement } from '../../../HtmlComponents/InputElement'
import { useTranslation } from 'react-i18next'

const InputsExpenses = () => {
  const {
    note, setNote,
    amount, setAmount,
    createdAt, setCreatedAt
  } = useContext(DataExpenseContext)

  const { t } = useTranslation()

  return (
    <>
      <InputElement name={t("Note")} placeholder={t("Donner un note")} value={note} setValue={setNote}/>
      <InputElement type='number' name={t("Montant")} placeholder={t("Donner le montant")}  value={amount} setValue={setAmount}/>
      <InputElement type='date' name={t("Date")}  value={createdAt} setValue={setCreatedAt}/>
    </>
  )
}

export default InputsExpenses